"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_redux_1 = require("react-redux");
var core_1 = require("@material-ui/core");
var i18next_1 = __importDefault(require("i18next"));
var landing_main_svg_1 = __importDefault(require("@assets/components/home/rotating-links-graphic/landing-main.svg"));
var RotatingLinks_1 = __importDefault(require("./RotatingLinks"));
var useStyles = (0, core_1.makeStyles)(function (theme) {
    return (0, core_1.createStyles)({
        heroContainer: {
            position: 'relative',
            width: '100vw',
            maxWidth: function (props) { return "".concat(props.targetImageWidthPx, "px"); },
            height: function (props) { return "".concat(props.heightToWidthRatio * 100, "vw"); },
            maxHeight: function (props) {
                return "".concat(props.targetImageWidthPx * props.heightToWidthRatio, "px");
            },
            marginLeft: 'auto',
            marginRight: '-1.5px',
            marginBottom: function (props) {
                return "max(".concat(props.linkBoxHeightToImageWidth * -50, "vw, calc((").concat(-1 * props.linkBoxHeightToImageWidth * props.targetImageWidthPx, "px / 2)))");
            },
            '@media screen\\0': {
                marginBottom: function (props) {
                    return "calc((".concat(-1 * props.linkBoxHeightToImageWidth * props.targetImageWidthPx, "px / 2))");
                },
            },
        },
        heroImage: {
            position: 'absolute',
            width: '100vw',
            maxWidth: function (props) { return "".concat(props.targetImageWidthPx, "px"); },
            height: function (props) { return "".concat(props.heightToWidthRatio * 100, "vw"); },
            maxHeight: function (props) {
                return "".concat(props.targetImageWidthPx * props.heightToWidthRatio, "px");
            },
            verticalAlign: 'top',
            left: 0,
            bottom: 0,
        },
        rotatingLinks: {
            position: 'absolute',
            width: function (props) { return "".concat(props.linkBoxWidthToImageWidth * 100, "vw"); },
            maxWidth: function (props) {
                return "".concat(props.linkBoxWidthToImageWidth * props.targetImageWidthPx, "px");
            },
            height: function (props) {
                return "".concat(props.linkBoxHeightToImageWidth * 100, "vw");
            },
            maxHeight: function (props) {
                return "".concat(props.linkBoxHeightToImageWidth * props.targetImageWidthPx, "px");
            },
            fontSize: 'min(3.25vw, 26px)',
            fontWeight: 400,
            color: theme.palette.secondary.contrastText,
            opacity: 0.7,
            right: 0,
            bottom: 0,
            display: 'flex',
            alignItems: 'center',
            paddingLeft: function (props) {
                return "".concat(props.linkBoxWidthToImageWidth *
                    props.rotatingLinkLeftMarginToLinkBox *
                    100, "vw");
            },
            '@media screen\\0': {
                fontSize: '26px',
            },
        },
    });
});
var RotatingLinksGraphic = function () {
    var classes = useStyles({
        heightToWidthRatio: 419 / 765,
        linkBoxWidthToImageWidth: 662.01 / 765,
        linkBoxHeightToImageWidth: 98.0139235 / 765,
        rotatingLinkLeftMarginToLinkBox: 3.5 / 100,
        // Specifies max width of the graphic in px.
        targetImageWidthPx: 765,
    });
    var linksToRotate = (0, react_redux_1.useSelector)(function (state) { return state.home.linksToRotate; });
    return (react_1.default.createElement("div", { className: classes.heroContainer },
        react_1.default.createElement("img", { className: classes.heroImage, src: landing_main_svg_1.default, alt: i18next_1.default.t('general.appTitle') }),
        react_1.default.createElement("div", { className: classes.rotatingLinks },
            react_1.default.createElement(RotatingLinks_1.default, { prefix: i18next_1.default.t('general.shortUrlPrefix'), strings: linksToRotate || [] }))));
};
exports.default = RotatingLinksGraphic;
